module.exports = __webpack_public_path__ + "static/img/banner2.f026f3b1.png";